import "./App.css"
import React from "react";
import FoodSearch from "./components/FoodSearch";
import RecipeBuilder from "./components/ReciepeBuilder";


function App() {
  return (
    <>
    <header className="main-header">
        <h1>🥗 Food Tracker</h1>
        <p>Track meals, calories, and build custom recipes</p>
      </header>

      <div className="container">
        <FoodSearch />
        <RecipeBuilder />
      </div>
    
    </>
  );
}

export default App;